import * as React from 'react';
type Props = {
  className?: string;
};
export function Tuna({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Tuna"
      className={className}
    >
      <path
        d="M37.6986 23.5512L35.2479 22.0733L40.1495 19.7236L37.6986 23.5512Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23573 27.7829C9.24482 28.3702 8.77677 28.8659 8.18933 28.8751C7.59266 28.8935 7.10627 28.4253 7.09708 27.8287C7.07871 27.2412 7.54684 26.7456 8.14332 26.7364C8.73076 26.718 9.21732 27.1861 9.23573 27.7829Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.905 24.5426L21.6452 30.4721L18.0012 26.0386L27.905 24.5426Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23573 27.7829C9.24482 28.3702 8.77677 28.8659 8.18933 28.8751C7.59266 28.8935 7.10627 28.4253 7.09708 27.8287C7.07871 27.2412 7.54684 26.7456 8.14332 26.7364C8.73076 26.718 9.21732 27.1861 9.23573 27.7829Z"
        fill="currentColor"
      />
      <path
        d="M12.8713 22.9321C12.8713 22.9321 15.7198 28.1587 13.1018 33.1671"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.905 24.5426L21.6452 30.4721L18.0012 26.0386L27.905 24.5426Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.394 19.2005V19.1637C14.394 16.8324 14.9723 14.5469 16.0737 12.5C17.6892 14.3266 19.6993 15.7677 21.9481 16.6947L29.9703 20.0266"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.3002 34.3912C47.1254 32.1882 46.538 29.7743 46.538 27.3602C46.538 24.8637 47.1621 22.367 48.4104 20.1183L40.4157 25.3409C38.479 24.0468 36.6157 22.9728 34.8259 22.0732C33.2012 21.2655 31.6317 20.6047 30.1171 20.0814L29.9703 20.0265C23.7931 17.9154 18.5979 18.0531 14.394 19.2003C5.67421 21.5869 1.25 28.3331 1.25 28.3331C19.6902 48.9945 40.5167 29.8936 40.5167 29.8936L48.75 35.2355L48.3002 34.3912ZM8.18922 28.8748C7.59254 28.8932 7.10615 28.425 7.09696 27.8284C7.07858 27.2409 7.54671 26.7453 8.14322 26.7361C8.73066 26.7177 9.21722 27.1858 9.23562 27.7826C9.2446 28.3699 8.77667 28.8656 8.18922 28.8748ZM21.6452 30.4718L18.0012 26.0385L27.9051 24.5424L21.6452 30.4718Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1668 32.5372L39.6083 36.3646L34.7159 34.015L37.1668 32.5372Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
